import { type DataWarehouseRefFragment } from '@spotify/confidence-graphql';

export const getWarehouseTypeLabel = (
  config: DataWarehouseRefFragment['config'],
): string => {
  if (config.bigQueryConfig) return 'BigQuery';
  if (config.dataBricksConfig) return 'Databricks';
  if (config.snowflakeConfig) return 'Snowflake';
  if (config.redshiftConfig) return 'Redshift';
  return 'Unknown';
};
